import { useAreFeatureFlagsReady } from './use-are-feature-flags-ready';
import { useEnableInsurancePromoExperiment } from './use-enable-insurance-promo-experiment';
import { useEnableInsurancePromoExtended } from './use-enable-insurance-promo-extended';

export const useShowInsurancePromoExtendedUi = () => {
  const areFeatureFlagsReady = useAreFeatureFlagsReady();
  const isPromoExperimentEnabled = useEnableInsurancePromoExperiment();
  const isPromoExtendedEnabled = useEnableInsurancePromoExtended();
  return areFeatureFlagsReady && isPromoExperimentEnabled && isPromoExtendedEnabled;
};
